import React from "react";

export interface ModernSignatureIconProps {
    className?: string;
    size?: number;
}

function iconStyle(size: number): React.CSSProperties {
    return { width: size, height: size, display: "block", flexShrink: 0 };
}

/** Undo last stroke icon (Lucide undo-2). */
export function SignatureUndoIcon({
    className,
    size = 16,
}: ModernSignatureIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            style={iconStyle(size)}
            aria-hidden="true"
        >
            <path d="M9 14 4 9l5-5" />
            <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
        </svg>
    );
}

/** Empty-state hint icon (Lucide signature). */
export function SignatureHintIcon({
    className,
    size = 20,
}: ModernSignatureIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            style={iconStyle(size)}
            aria-hidden="true"
        >
            <path d="m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284" />
            <path d="M3 21h18" />
        </svg>
    );
}
